import { IconProps } from '.';
const ChevronIcon = ({
  color = 'var(--color-sage-500)',
  customClasses,
  ...rest
}: IconProps) => {
  return (
    <svg
      className={customClasses}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.9997 13.1724L16.9495 8.22266L18.3637 9.63687L11.9997 16.0009L5.63574 9.63687L7.04996 8.22266L11.9997 13.1724Z"
        fill={color}
      />
    </svg>
  );
};

export default ChevronIcon;
